export default __webpack_public_path__ + "static/media/hand-w-money.b0bf9e3e.svg";